/**
 * documentsLoader.js. DO NOT apply var to these values. The vars file has not loaded yet.
 * Created by calhosh on 9/22/2020.
 */
import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

function documentsLoader() {
	return (
		<DocumentSkeletonLoader>
			<section className="main-wrapper mainResponsiveWrapper">
				<section className="instructional-text">
					<Skeleton circle={false} height={'100%'} width={'100%'} />
				</section>
				<section className="document-section">
					<section className="document-icon">
						<Skeleton circle={false} height={'100%'} width={'100%'} />
					</section>
					<section className="document-name-text">
						<Skeleton circle={false} height={'100%'} width={'100%'} />
					</section>
				</section>
				<section className="related-tasks-section">
					<section className="row-inner1">
						<section className="task-row-content">
							<Skeleton circle={false} height={'100%'} width={'100%'} />
						</section>
						<section className="task-row-content">
							<Skeleton circle={false} height={'100%'} width={'100%'} />
						</section>
						<section className="task-row-content">
							<Skeleton circle={false} height={'100%'} width={'100%'} />
						</section>
					</section>
				</section>
			</section>
		</DocumentSkeletonLoader>
	);
}

export default documentsLoader;

const DocumentSkeletonLoader = styled.section`
	.instructional-text {
		height: 4rem;
		margin-top: 6rem;
	}

	.document-section {
		display: flex;
		margin: 4.5rem 0rem;

		.document-icon {
			width: 6rem;
			height: 6rem;
		}

		.document-name-text {
			width: 80rem;
			margin-left: 3rem;
		}
	}

	.related-tasks-section {
		.task-row-content {
			height: 4rem;
			width: 20%;
			margin: 1rem 0;
		}
		.row-inner1 {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
	}
`;
